import React from 'react';

export default function Toast({message, onClose, type='info'}) {
  if (!message) return null;
  const bg = type === 'error' ? 'bg-red-500' : type === 'success' ? 'bg-green-500' : 'bg-slate-800';
  return (
    <div className={`fixed bottom-4 right-4 p-3 rounded text-white shadow ${bg}`} role="status">
      <div className="flex items-start gap-2">
        <div className="flex-1">{message}</div>
        <button onClick={onClose} className="font-bold px-2">×</button>
      </div>
    </div>
  );
}
